import { Component, createMemo, createSignal, onMount } from 'solid-js'
import { AppSchema } from '../../../common/types/schema'
import { AutoPreset, getPresetOptions } from '../../shared/adapter'
import { chatStore, i18nStore, presetStore, toastStore } from '../../store'
import { isDefaultPreset } from '../../../common/default-preset'
import { isEligible } from './util'

const ForcePresetModal: Component<{ chat: AppSchema.Chat; show: boolean; close: () => void }> = (
  props
) => {
  const i18n = i18nStore((s) => ({ t: s.t }))
  const presets = presetStore((s) => s.presets)

  const options = createMemo(() => {
    const opts = getPresetOptions(presets, { builtin: true }).filter((pre) => pre.value !== 'chat')
    return [{ label: i18n.t.chat_system_built_in_preset_horde, value: AutoPreset.service }].concat(opts)
  })

  const [presetId, setPresetId] = createSignal(props.chat.genPreset || options()[0].value)
  const [preset] = createSignal<AppSchema.UserGenPreset>()
  const [service] = createSignal<string>()

  const savePreset = () => {
    const id = presetId()
    if (!id) {
      toastStore.error(i18n.t.chat_please_select_preset)
      return
    }

    chatStore.assignChatPreset(props.chat._id, id, props.close)

    const userPreset = preset()
    const svc = service()
    if (userPreset && !isDefaultPreset(userPreset._id)) {
      if (!svc) return

      presetStore.updatePreset(userPreset._id, { service: svc as any })
    }
  }

  onMount(() => {
    const eligible = isEligible()
    if (!eligible) {
      setPresetId('horde')
      savePreset()
      return
    }

    setPresetId('agnai')
    savePreset()
  })

  return null
}

export default ForcePresetModal
